import OtsMainTitle from "./OtsMainTitle"

OtsMainTitle.install = Vue => {
    vue.component(OtsMainTitle.name,OtsMainTitle)
}


export default OtsMainTitle